var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "searchWrapper",
      class: ["dc-post-grid-input-wrapper", { focused: _vm.focused }],
      on: {
        click: function($event) {
          return _vm.focusSearch()
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value"
          }
        ],
        ref: "searchInput",
        class: ["dc-post-grid-search-input"],
        attrs: {
          id: "dc-post-grid-search-input",
          name: "dc-post-grid-search",
          type: "search",
          placeholder: _vm.searchFormPlaceholder
        },
        domProps: { value: _vm.value },
        on: {
          focus: function($event) {
            _vm.focused = true
          },
          blur: function($event) {
            _vm.focused = false
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }